import React from 'react';
import Button from './button';
import ResourceActionButton from './resource-action-button';
import TableActionButton from './table-action-button';

export default Button;

// The following are premade buttons that are very common in all the VHT applications.
// These are here for convenience and to make use of styles, icons and text more consistant.
/* eslint-disable react/display-name */
Button.SaveResource = props => <ResourceActionButton action="save" {...props} />;
Button.UpdateResource = props => <ResourceActionButton action="update" {...props} />;
Button.AddResource = props => <ResourceActionButton action="add" {...props} />;
Button.NewResource = props => <ResourceActionButton action="new" {...props} />;
Button.DeleteResource = props => <ResourceActionButton action="delete" {...props} />;
Button.EditResource = props => <ResourceActionButton action="edit" {...props} />;
Button.ImportResource = props => <ResourceActionButton action="import" {...props} />;

Button.TableEdit = props => <TableActionButton action="edit" {...props} />;
Button.TableDelete = props => <TableActionButton action="delete" {...props} />;
/* eslint-enable react/display-name */
